<template>
  <div class="mt-2">
    <icon-view
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-calendar-edit text-orange"
      :title="iconTitle"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row">
      <div
        :class="{
          'col-12 col-md-3': isEvents || isWorkshop,
          'col-12 col-md-6': !(isEvents || isWorkshop)
        }"
      >
        <ValidationProvider name="area" v-slot="{ errors }" rules="required">
          <custom-dropdown
            v-model="model.area"
            label="Área:"
            placeholder="Área"
            fieldkey="id"
            fieldname="name"
            :options="options.areas"
            :error="errors[0]"
            custom-error-msg="Campo requerido"
            :disabled="readOnly"
        /></ValidationProvider>
      </div>
      <div
        :class="{
          'col-12 col-md-3': isEvents || isWorkshop,
          'col-12 col-md-6': !(isEvents || isWorkshop)
        }"
      >
        <ValidationProvider
          name="category"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-dropdown
            v-model="model.category"
            label="Categoría:"
            placeholder="Categoría"
            fieldkey="id"
            fieldname="name"
            :options="options.categories"
            :error="errors[0]"
            custom-error-msg="Campo requerido"
            :disabled="readOnly"
          />
        </ValidationProvider>
      </div>
      <div v-if="isEvents || isWorkshop" class="col-12 col-md-3">
        <ValidationProvider
          name="cost"
          v-slot="{ errors }"
          rules="required|min_value:0"
        >
          <custom-input
            label="Costo:"
            type="Number"
            :error="errors[0]"
            :disabled="readOnly"
            v-model="model.cost"
            custom-error-msg="Campo requerido y mayor de 0"
            :min="0"
          />
        </ValidationProvider>
      </div>
      <div v-if="isEvents || isWorkshop" class="col-12 col-md-3">
        <ValidationProvider
          name="register"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            label="Registro:"
            type="text"
            :error="errors[0]"
            :disabled="readOnly"
            v-model="model.register"
            custom-error-msg="Campo requerido"
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import CustomInput from "CustomInput";
import CustomDropdown from "custom-drop-down";
import {
  getItemCategoryTypes,
  getItemAreaTypes
} from "@/services/operations/dashboard-management";
import TYPES from "@/utils/constants/operations-dashboard-management/scheduleItemTypes";

export default {
  name: "NewsInfo",
  components: {
    IconView,
    CustomDropdown,
    CustomInput
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: () => 0
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      options: {
        categories: [],
        areas: []
      }
    };
  },
  async mounted() {
    await this.getCategoryTypes();
    await this.getAreaTypes();
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isEvents() {
      return this.type === TYPES.Event;
    },
    isWorkshop() {
      return this.type === TYPES.Workshop;
    },
    isNews() {
      return this.type === TYPES.News;
    },
    iconTitle() {
      switch (this.type) {
        case TYPES.Workshop:
          return "Información de Taller";
        case TYPES.Event:
          return "Información de Evento";
        case TYPES.News:
          return "Información de Noticias";
        default:
          return "";
      }
    }
  },
  methods: {
    async getCategoryTypes() {
      const { data } = await getItemCategoryTypes();
      this.options.categories = data;
    },
    async getAreaTypes() {
      const { data } = await getItemAreaTypes();
      this.options.areas = data;
    }
  },
};
</script>

<style scoped></style>
